import(/* webpackMode: "eager" */ "/app/node_modules/@ark-ui/react/dist/components/tabs/tab-content.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@ark-ui/react/dist/components/tabs/tab-indicator.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@ark-ui/react/dist/components/tabs/tab-list.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@ark-ui/react/dist/components/tabs/tab-trigger.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@ark-ui/react/dist/components/tabs/tabs-context.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@ark-ui/react/dist/components/tabs/tabs-root-provider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@ark-ui/react/dist/components/tabs/tabs-root.js");
;
import(/* webpackMode: "eager", webpackExports: ["tabsAnatomy"] */ "/app/node_modules/@ark-ui/react/dist/components/tabs/tabs.anatomy.js");
;
import(/* webpackMode: "eager", webpackExports: ["useTabsContext"] */ "/app/node_modules/@ark-ui/react/dist/components/tabs/use-tabs-context.js");
;
import(/* webpackMode: "eager", webpackExports: ["useTabs"] */ "/app/node_modules/@ark-ui/react/dist/components/tabs/use-tabs.js");
;
import(/* webpackMode: "eager", webpackExports: ["AccordionContext","AccordionItem","AccordionItemBody","AccordionItemContent","AccordionItemContext","AccordionItemIndicator","AccordionItemTrigger","AccordionPropsProvider","AccordionRoot","AccordionRootProvider"] */ "/app/node_modules/@chakra-ui/react/dist/esm/components/accordion/accordion.js");
;
import(/* webpackMode: "eager", webpackExports: ["AlertContent","AlertDescription","AlertIndicator","AlertRoot","AlertPropsProvider","AlertTitle"] */ "/app/node_modules/@chakra-ui/react/dist/esm/components/alert/alert.js");
;
import(/* webpackMode: "eager", webpackExports: ["IconButton"] */ "/app/node_modules/@chakra-ui/react/dist/esm/components/button/icon-button.js");
;
import(/* webpackMode: "eager", webpackExports: ["CardBody","CardDescription","CardFooter","CardHeader","CardPropsProvider","CardRoot","CardTitle"] */ "/app/node_modules/@chakra-ui/react/dist/esm/components/card/card.js");
;
import(/* webpackMode: "eager", webpackExports: ["Center"] */ "/app/node_modules/@chakra-ui/react/dist/esm/components/center/center.js");
;
import(/* webpackMode: "eager", webpackExports: ["CodeBlockAdapterProvider"] */ "/app/node_modules/@chakra-ui/react/dist/esm/components/code-block/code-block-adapter-provider.js");
;
import(/* webpackMode: "eager", webpackExports: ["CodeBlockCode","CodeBlockCodeText","CodeBlockCollapseIndicator","CodeBlockCollapseText","CodeBlockCollapseTrigger","CodeBlockContent","CodeBlockContext","CodeBlockControl","CodeBlockCopyIndicator","CodeBlockCopyTrigger","CodeBlockFooter","CodeBlockHeader","CodeBlockOverlay","CodeBlockRoot","CodeBlockTitle"] */ "/app/node_modules/@chakra-ui/react/dist/esm/components/code-block/code-block.js");
;
import(/* webpackMode: "eager", webpackExports: ["Float"] */ "/app/node_modules/@chakra-ui/react/dist/esm/components/float/float.js");
;
import(/* webpackMode: "eager", webpackExports: ["Heading"] */ "/app/node_modules/@chakra-ui/react/dist/esm/components/heading/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["Image"] */ "/app/node_modules/@chakra-ui/react/dist/esm/components/image/image.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@chakra-ui/react/dist/esm/components/link/link-box.js");
;
import(/* webpackMode: "eager", webpackExports: ["Link"] */ "/app/node_modules/@chakra-ui/react/dist/esm/components/link/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["SimpleGrid"] */ "/app/node_modules/@chakra-ui/react/dist/esm/components/simple-grid/simple-grid.js");
;
import(/* webpackMode: "eager", webpackExports: ["HStack"] */ "/app/node_modules/@chakra-ui/react/dist/esm/components/stack/h-stack.js");
;
import(/* webpackMode: "eager", webpackExports: ["VStack"] */ "/app/node_modules/@chakra-ui/react/dist/esm/components/stack/v-stack.js");
;
import(/* webpackMode: "eager", webpackExports: ["TabsContent","TabsContentGroup","TabsIndicator","TabsList","TabsPropsProvider","TabsRoot","TabsRootProvider","TabsTrigger"] */ "/app/node_modules/@chakra-ui/react/dist/esm/components/tabs/tabs.js");
;
import(/* webpackMode: "eager", webpackExports: ["Text"] */ "/app/node_modules/@chakra-ui/react/dist/esm/components/text/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/RoleBadge.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Prose"] */ "/app/src/components/ui/prose.tsx");
